var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgQLetter = function SvgQLetter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.999 25l.001-.015C46 10.808 37.97 2 25.044 2 12.26 2 4 11.022 4 24.985l.001.015c.006 14.187 8.068 23 21.044 23 2.977 0 5.679-.488 8.098-1.381l2.033 2.948A1 1 0 0036 50h6a1 1 0 00.824-1.567l-3.706-5.39c4.401-3.975 6.878-10.178 6.881-18.043zM31 32h-6a1 1 0 00-.824 1.567l4.118 5.99a12.09 12.09 0 01-3.251.443C17.56 40 13 34.125 13 24.986 13 15.819 17.674 10 25.043 10 32.384 10 37 15.819 37 24.986c0 4.396-1.078 8.016-3.002 10.609l-2.173-3.161A1.002 1.002 0 0031 32z"
  })));
};
export default SvgQLetter;